import { KnownUserStatus } from '@groundfloor-platform/mgmt-service-g-sdk';
import { useCallback } from 'react';
import { useMutationEditUser } from '../../users.queries';
import { UserDetailsActions } from '../actions/user-details.actions';

export function useUserStatusChange(setAction: (action: UserDetailsActions | null) => void, userId: string) {
  const { mutate } = useMutationEditUser(userId);

  const changeStatus = useCallback(
    (status: KnownUserStatus) => {
      mutate(
        { status },
        {
          onSuccess() {
            setAction(UserDetailsActions.STATUS_CHANGE_SUCCESS);
          },
          onError() {
            setAction(UserDetailsActions.STATUS_CHANGE_ERROR);
          }
        }
      );
    },
    [mutate, setAction]
  );

  const activateUser = useCallback(() => changeStatus(KnownUserStatus.Active), [changeStatus]);

  const deactivateUser = useCallback(() => changeStatus(KnownUserStatus.Inactive), [changeStatus]);

  return { activateUser, deactivateUser };
}
